module.exports = __webpack_public_path__ + "static/media/Razorback511_4c.edc6aa1d.svg";